var AppDispatcher = require('../dispatcher/AppDispatcher');
var LanguageConstants = require('../constants/LanguageConstants');
var AppConstants = require('../constants/AppConstants');
var EventEmitter = require('events').EventEmitter;
var assign = require('object-assign');
var _ = require('underscore');

var listenerCount = 0;
var CHANGE_EVENT = 'change';

var language = {
    lang: 'rs'
};

var _languageLoaded = function(data) {
    language.lang = data.data;
};

var LanguageStore = assign({}, EventEmitter.prototype,{
    emitChange: function(){
        this.emit(CHANGE_EVENT)
    },
    addChangeListener: function(callback){
        listenerCount++;
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getLanguage: function() {
        return language
    }
});

LanguageStore.dispatchToken = AppDispatcher.register(function(action){
    var id;
    switch(action.type){

        case LanguageConstants.LOAD_LANGUAGE_SUCCESS:
            _languageLoaded(action.data);
            break;

        default:
        return null;
    }
    LanguageStore.emitChange(id);

})

module.exports = LanguageStore



/** WEBPACK FOOTER **
 ** ./modules/store/LanguageStore.js
 **/